import { Grid } from '@coolblue-development/freddy';
import type { ReactNode } from 'react';

const SelectorGrid = ({ children }: { children: ReactNode }) => (
  <Grid
    templateColumns={{
      xs: 'repeat(2, 1fr)',
      sm: 'repeat(3, 1fr)',
      md: 'repeat(4, 1fr)'
    }}
    gap={200}
    mt={200}
  >
    {children}
  </Grid>
);

export default SelectorGrid;
